import { css } from "lit";

/**
 * Der Register-Reiter — EINE Form für die Abschnittsleiste und jeden Umschalter
 * (Liste/Monat im Kalender): Mono-Versal, 44 px hoch, der aktive Eintrag in
 * Tinte mit Petrol-Unterstrich (KONZEPT-gestaltungssystem.md, 8.2 und 8.5).
 * Einträge sind Links (Abschnitte) oder Knöpfe (Umschalter) — dieselben Regeln.
 */
export const reiterStyles = css`
  .reiter {
    display: flex;
    gap: var(--portal-space-6);
    margin: 0;
    padding: 0;
    list-style: none;
    border-bottom: 1px solid var(--portal-linie);
    overflow-x: auto;
    scroll-snap-type: x proximity;
    scrollbar-width: none;
  }
  .reiter::-webkit-scrollbar {
    display: none;
  }
  .reiter > li {
    flex: none;
    scroll-snap-align: start;
  }
  .reiter a,
  .reiter button {
    display: inline-flex;
    align-items: center;
    min-height: var(--portal-touch);
    padding: 0 var(--portal-space-1);
    border: 0;
    border-bottom: 2px solid transparent;
    border-radius: 0;
    background: none;
    font-family: var(--portal-font-mono);
    font-size: var(--portal-size-meta);
    color: var(--portal-ink-2);
    text-transform: uppercase;
    letter-spacing: var(--portal-tracking-caps);
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
  }
  .reiter a:hover,
  .reiter button:hover {
    color: var(--portal-ink);
  }
  .reiter a[aria-current],
  .reiter button[aria-current],
  .reiter button[aria-pressed="true"],
  .reiter button[aria-selected="true"] {
    color: var(--portal-ink);
    border-bottom-color: var(--portal-akzent);
  }
  .reiter a:focus-visible,
  .reiter button:focus-visible {
    outline: var(--portal-focus-width) solid var(--portal-akzent);
    outline-offset: -2px;
  }
`;
